// latestData.js

import { getLoadingElement } from './loadingIndicator.js';
import { init as initPowerFlow } from './powerFlow.js';

const latestDataElement = document.querySelector('[data-latest-data]');

if (latestDataElement !== null) {
  let updateLatestDataTimeout = null;

  const updateLatestData = () => {
    const currentSec = new Date().getSeconds();
    const secsUntilNextMinute = 60 - currentSec;
    const remain = secsUntilNextMinute + 5;

    if (updateLatestDataTimeout !== null) {
      window.clearTimeout(updateLatestDataTimeout);
    }
    updateLatestDataTimeout = window.setTimeout(updateLatestData, 1000 * remain);

    const url = latestDataElement.getAttribute('data-latest-data');

    try {
      const loadingElement = getLoadingElement(latestDataElement.parentElement);

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('HTTP error ' + response.status);
          }
          return response.json();
        })
        .then(json => {
          latestDataElement.querySelectorAll('[data-field]').forEach(valueElement => {
            valueElement.innerText = json[valueElement.getAttribute('data-field')] ?? '-';
          });

          document.dispatchEvent(new CustomEvent('latestDataUpdate', {
            detail: {
              pvToConsumer: json['flowPVToConsumerNumeric'] ?? 0,
              pvToGrid: json['flowPVToGridNumeric'] ?? 0,
              gridToConsumer: json['flowGridToConsumerNumeric'] ?? 0
            }
          }));
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          loadingElement?.classList.remove('show');
        });

    } catch (e) {
      console.warn('Latest data failure.');
      console.error(e);
    }
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (updateLatestDataTimeout !== null) {
        window.clearTimeout(updateLatestDataTimeout);
      }
    } else {
      updateLatestData();
    }
  });

  initPowerFlow(document.getElementById('svg-container'));

  // Initial update on page load.
  updateLatestData();
}
